import CancelIcon from '@mui/icons-material/Cancel';
import PrintIcon from '@mui/icons-material/Print';
import { IconButton,Stack,Tooltip,Typography } from '@mui/material';
import { useCallback,useRef,useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FaGear } from "react-icons/fa6";
import { useReactToPrint } from 'react-to-print';
import { perguntasType,respostasType } from '../../service/Pesquisas';
import { trackEventMatomo } from '../../helpers/matomo';

export default function ModalRespostas({
  selected,
  openModal,
  setOpenModal,
}: {
  selected: respostasType,
  openModal: boolean,
  setOpenModal: Function
}) {
  const { t } = useTranslation('translation');

  const [showOptions, setShowOptions] = useState(false);
  const [showType, setShowType] = useState(true);
  const [ocultaErrado, setOcultaErrado] = useState(true);


  const componentRef = useRef(null);

  const handleAfterPrint = useCallback(() => {
    console.info("`onAfterPrint` called");
  }, []);

  const handleBeforePrint = useCallback(() => {
    return Promise.resolve();
  }, []);

  const printFn = useReactToPrint({
    pageStyle: {
      padding: '20px'
    },
    contentRef: componentRef,
    documentTitle: selected?.nome,
    onAfterPrint: handleAfterPrint,
    onBeforePrint: handleBeforePrint,
  });

  const tipoResposta = (value: string) => {
    switch (value) {
      case "alternativa":
        return `${t('Researches.alternative')}`;
      case 'multiple':
        return `${t('Researches.multipleChoice')}`;
      case 'textoCurto':
        return `${t('Researches.shortText')}`;
      case 'textoLongo':
        return `${t('Researches.longText')}`;
      case 'horario':
        return `${t('Researches.time')}`;
      case 'data':
        return `${t('Researches.date')}`;
      case 'numero':
        return `${t('Researches.number')}`;
      case 'foto':
        return `${t('Researches.photo')}`;
      default: return '';
    }
  };

  const exibeResposta = (value: perguntasType) => {
    switch (value.tipo) {
      case "alternativa":
        return (
          <table>
            <tbody>
              {value.alternativas.map((ele, index) => (
                index === value.resposta
                  ? <tr key={ele}>
                    <th>{ele}</th>
                  </tr>
                  : (ocultaErrado
                    && <tr key={ele}>
                      <td>{ele}</td>
                    </tr>
                  )
              ))}
            </tbody>
          </table>);
      case 'multiple':
        return (
          <table>
            <tbody>
              {value.alternativas.map((ele, index) =>
                (value?.resposta as unknown as number[])?.includes(index)
                  ? <tr key={ele}>
                    <th>{ele}</th>
                  </tr>
                  : (ocultaErrado &&
                    <tr key={ele}>
                      <td>{ele}</td>
                    </tr>
                  )
              )}
            </tbody>
          </table>
        );
      case 'textoCurto':
      case 'horario':
      case 'data':
      case 'textoLongo':
      case 'numero':
      case 'foto':
        return <th>{value?.resposta}</th>;
      default: return '';
    }
  };
  return (
    <div className={`modal ${openModal ? 'is-active ' : ''}`}>
      <div className="modal-background"></div>
      <div className="modal-card">
        <header style={{
          display: 'flex',
          flexDirection: 'column',
        }} className="modal-card-head">
          <Stack width='100%' direction='row' justifyContent='space-between' alignItems='center'>
            <Tooltip title={t('options')}>
              <IconButton onClick={() => {
                trackEventMatomo('respostas de pesquisa legado', 'click', 'botão', showOptions ? 'fecha opções de visualização' : 'abre opções de visualização');
                setShowOptions(!showOptions);
              }}>
                <FaGear />
              </IconButton>
            </Tooltip>
            <Tooltip title={t('checklists.printConfig.Imprimir')}>
              <IconButton color='info' onClick={() => {
                trackEventMatomo('respostas de pesquisa legado', 'click', 'botão', 'imprime respostas');
                printFn();
              }}><PrintIcon /></IconButton>
            </Tooltip>
            <IconButton color='error' onClick={() => {
              trackEventMatomo('respostas de pesquisa legado', 'click', 'botão', 'fecha respostas');
              setOpenModal(!openModal);
            }}>
              <CancelIcon />
            </IconButton>
          </Stack>
          {showOptions &&
            <Stack
              padding={2}
              width={'100%'}
              direction='column'
              spacing={1}
              justifyContent={'flex-start'}
              alignItems={'flex-start'}
              sx={{ borderRadius: '10px', backgroundColor: '#EEEEEE' }}
            >
              <span style={{ fontWeight: 600, color: 'gray', fontSize: '14px' }}>
                <input onChange={() => {
                  trackEventMatomo('respostas de pesquisa legado', 'click', 'checkbox', 'altera exibição de opções não selecionadas');
                  setOcultaErrado(!ocultaErrado);
                }} type='checkbox' />&nbsp;{t('Researches.hideUnselectedOptions')}
              </span>
              <span style={{ fontWeight: 600, color: 'gray', fontSize: '14px' }}>
                <input onChange={() => {
                  trackEventMatomo('respostas de pesquisa legado', 'click', 'checkbox', 'altera exibição de tipos de pergunta');
                  setShowType(!showType);
                }} type='checkbox' />&nbsp;{t('Researches.hideQuestionTypes')}
              </span>
            </Stack>
          }
        </header>
        <section className="modal-card-body">
          <Typography
            color='textDisabled'
            fontSize={18}
            fontWeight={600}
          >
            {t('Researches.answersMadeIn')} {new Date(selected?.inicio).toLocaleString('pt-BR')} {t('Researches.until')} {new Date(selected?.fim)?.toLocaleString('pt-BR')}
          </Typography>
          <Stack ref={componentRef}>
            {selected.perguntas.map((pergunta, index) => (
              <Stack direction='column' spacing={1} key={`${index}|${pergunta.id}`} justifyContent={'flex-start'} alignItems={'flex-start'} marginTop={2} marginBottom={2}>
                <span style={{ fontWeight: 600, color: 'gray' }}>({index + 1}) {pergunta.questao}</span>
                {showType && <span style={{ fontWeight: 600, color: 'gray', fontSize: '12px' }}>({tipoResposta(pergunta.tipo)})</span>}
                <span>{exibeResposta(pergunta)}</span>
              </Stack>
            ))}
          </Stack>
        </section>
      </div>
    </div >
  );
}
